import { SET_VISIBILITY } from './navigation-drawer-mutation-types'
import { RESET } from './mutation-types'
export const navigationDrawer = {
  namespaced: true,
  state: {
    visible: false
  },
  getters: {
    getVisibility: (state) => {
      return state.visible
    }
  },
  actions: {
    setVisibility ({ commit }, { val }) {
      commit(SET_VISIBILITY, { val })
    },
    reset ({ commit }) {
      commit(RESET)
    }
  },
  mutations: {
    [SET_VISIBILITY] (state, { val }) {
      state.visible = val
    },
    [RESET] (state) {
      state.visible = false
    }
  }
}
